import { useParams } from "react-router";

import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableCellLink from "ds/components/Table/Row/CellLink";
import Box from "ds/components/Box";
import Icon from "ds/components/Icon";
import { Commit } from "components/icons/generated";
import { getRepoRevisionUrl } from "utils/spaceliftRepo";

import { FileTreeNode } from "../../../fileTreeHelpers";

const CommitCell = ({ item, ...cellProps }: TableSimpleCellProps<FileTreeNode>) => {
  const { repoId } = useParams<{ repoId: string }>();

  if (item.type === "parent") {
    return (
      <TableSimpleCell {...cellProps}>
        <TableCellEmpty />
      </TableSimpleCell>
    );
  }

  const revision = item.file?.revision;

  return (
    <TableSimpleCell {...cellProps}>
      {revision?.sha ? (
        <Box direction="row" align="center" gap="small">
          <Icon src={Commit} color="info" noShrink />
          <TableCellLink href={getRepoRevisionUrl(repoId!, revision.sha)} variant="primary">
            {revision.sha.slice(0, 7)}
          </TableCellLink>
        </Box>
      ) : (
        <TableCellEmpty />
      )}
    </TableSimpleCell>
  );
};

export default CommitCell;
